import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:/openy-admin-all/openy-wxms-web2026-09-01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import QRCode from 'qrcodejs2';
import { loadH5Info, getApplyList, editH5Info, getAppletCode } from "@/api/mini";
import { saveSpecial } from '@/api/special';
import { getQrcodeUrl } from '@/api/create';
import { cleanSpelChar } from "@/utils/index";
export default {
  data: function data() {
    return {
      id: '',
      type: '',
      name: '',
      obj: {},
      appletCode: "",
      copy_applet_url: "",
      dts: "",
      copy_url: "",
      preViewUrl: '',
      appImg: '',
      moduleId: '',
      show: false,
      isEdit: false,
      loading: true
    };
  },
  watch: {
    show: function show(val) {
      if (val) {
        var str_css = "body {overflow:hidden;}";
        var style = document.createElement("style");
        style.type = "text/css";
        style.innerHTML = str_css;
        document.getElementsByTagName("HEAD").item(0).appendChild(style);
      } else {
        var str_css = "body {overflow:auto;}";
        var style = document.createElement("style");
        style.type = "text/css";
        style.innerHTML = str_css;
        document.getElementsByTagName("HEAD").item(0).appendChild(style);
      }
    }
  },
  methods: {
    open: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, type, obj) {
        var _this = this;

        var t, apple, res, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (type) this.type = type;
                if (id) this.id = id;
                if (obj) this.obj = obj;

                if (type == 1 || type == 2) {
                  this.preViewUrl = process.env.VUE_APP_BASE_API3 + '/preview?appId=' + id + '&appType=' + type + '&isNoApp=1';
                } else {
                  this.preViewUrl = process.env.VUE_APP_BASE_API3 + '/preview?appId=' + id + '&special=' + obj.classId + '&isNoApp=1';
                }

                if (!(type == 1 || type == 3)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return loadH5Info(id);

              case 7:
                t = _context.sent;

              case 8:
                if (!(type == 1)) {
                  _context.next = 16;
                  break;
                }

                this.name = cleanSpelChar(t.datas.nickName);
                this.appImg = t.datas.appImg;

                if (t.datas.appStatus * 1 == 2) {}

                if (t.datas.domain) {
                  this.copy_url = t.datas.domain + (t.datas.appStatus * 1 == 2 ? '/layer' : '/preview');
                } else {
                  this.copy_url = process.env.VUE_APP_BASE_API3 + (t.datas.appStatus * 1 == 2 ? '/layer' : '/preview') + '?appId=' + t.datas.appid;
                }

                setTimeout(function () {
                  _this.$refs.exCodeRef.innerHTML = "";
                  new QRCode(_this.$refs.exCodeRef, {
                    width: 195,
                    // 设置宽度，单位像素
                    height: 195,
                    // 设置高度，单位像素
                    text: _this.copy_url // 设置二维码内容或跳转地址

                  });
                }, 300);
                _context.next = 45;
                break;

              case 16:
                if (!(type == 2)) {
                  _context.next = 25;
                  break;
                }

                _context.next = 19;
                return getQrcodeUrl(id);

              case 19:
                apple = _context.sent;

                if (!(apple.code !== '000000')) {
                  _context.next = 22;
                  break;
                }

                return _context.abrupt("return");

              case 22:
                if (apple.datas) {
                  this.appletCode = apple.datas.url;
                  this.name = cleanSpelChar(obj.name);
                }

                _context.next = 45;
                break;

              case 25:
                if (!(type == 3)) {
                  _context.next = 42;
                  break;
                }

                //专栏预览
                this.name = cleanSpelChar(obj.name);
                this.moduleId = obj.id;
                _context.next = 30;
                return getApplyList(sessionStorage.getItem("webId"));

              case 30:
                res = _context.sent;

                if (!(res.code !== "000000")) {
                  _context.next = 33;
                  break;
                }

                return _context.abrupt("return");

              case 33:
                if (!(res.datas.weappStatus == 2)) {
                  _context.next = 38;
                  break;
                }

                _context.next = 36;
                return getAppletCode(obj.classId, 41);

              case 36:
                result = _context.sent;

                if (result.code == "000000") {
                  this.appletCode = result.datas.playBillUrl;
                  this.copy_applet_url = result.datas.miniPath;
                }

              case 38:
                if (t.datas.domain) {
                  this.copy_url = t.datas.domain + '/special/' + obj.classId;
                } else {
                  this.copy_url = process.env.VUE_APP_BASE_API3 + '/special/' + obj.classId + '?appId=' + id;
                }

                setTimeout(function () {
                  _this.$refs.exCodeRef.innerHTML = "";
                  new QRCode(_this.$refs.exCodeRef, {
                    width: 150,
                    // 设置宽度，单位像素
                    height: 150,
                    // 设置高度，单位像素
                    text: _this.copy_url // 设置二维码内容或跳转地址

                  });
                }, 300);
                _context.next = 45;
                break;

              case 42:
                //模板预览
                this.name = cleanSpelChar(obj.name);
                this.moduleId = obj.id;
                setTimeout(function () {
                  _this.$refs.exCodeRef.innerHTML = "";
                  new QRCode(_this.$refs.exCodeRef, {
                    width: 195,
                    // 设置宽度，单位像素
                    height: 195,
                    // 设置高度，单位像素
                    text: process.env.VUE_APP_BASE_API3 + '/special/' + obj.classId + '?appId=' + id // 设置二维码内容或跳转地址

                  });
                }, 300);

              case 45:
                this.show = true;
                this.loading = false;

              case 47:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open(_x, _x2, _x3) {
        return _open.apply(this, arguments);
      }

      return open;
    }(),
    onCancel: function onCancel() {
      this.show = false;
    },
    handleClickEdit: function () {
      var _handleClickEdit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var obj, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.isEdit) {
                  _context2.next = 15;
                  break;
                }

                if (this.name) {
                  _context2.next = 4;
                  break;
                }

                this.$message.error("请输入网站名称！");
                return _context2.abrupt("return");

              case 4:
                if (!(this.name.length < 2 || this.name.length > 15)) {
                  _context2.next = 7;
                  break;
                }

                this.$message.error('网站名称请输入2～15个字');
                return _context2.abrupt("return");

              case 7:
                obj = {
                  nickName: this.name,
                  appImg: this.appImg
                };
                _context2.next = 10;
                return editH5Info(obj);

              case 10:
                res = _context2.sent;
                this.$message.success('修改成功');
                this.isEdit = false;
                _context2.next = 16;
                break;

              case 15:
                this.isEdit = true;

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleClickEdit() {
        return _handleClickEdit.apply(this, arguments);
      }

      return handleClickEdit;
    }(),
    // 修改专栏名称
    handleClickEditSpecial: function () {
      var _handleClickEditSpecial = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.isEdit) {
                  _context3.next = 16;
                  break;
                }

                if (this.name) {
                  _context3.next = 4;
                  break;
                }

                this.$message.error("请输入网站名称！");
                return _context3.abrupt("return");

              case 4:
                if (!(this.name.length > 20)) {
                  _context3.next = 7;
                  break;
                }

                this.$message.error('专栏名称最多20个字');
                return _context3.abrupt("return");

              case 7:
                data = {
                  name: this.name,
                  parentId: '0',
                  appid: this.id,
                  classTemplateId: '',
                  id: this.obj.classId
                };
                if (this.obj.imageUrl) data.imageUrl = this.obj.imageUrl;
                if (this.obj.intro) data.intro = this.obj.intro;
                _context3.next = 12;
                return saveSpecial(this.obj.classId, data);

              case 12:
                this.$message.success('修改成功');
                this.isEdit = false;
                _context3.next = 17;
                break;

              case 16:
                this.isEdit = true;

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleClickEditSpecial() {
        return _handleClickEditSpecial.apply(this, arguments);
      }

      return handleClickEditSpecial;
    }(),
    // 复制手机网站链接
    copyPerviewLink: function copyPerviewLink() {
      var Url2 = document.querySelector("#copy");
      Url2.value = this.copy_url;
      Url2.select(); // 选择对象

      document.execCommand("copy"); // 执行浏览器复制命令

      this.$message({
        message: "复制成功",
        type: 'success'
      });
    },
    // 复制小程序链接
    copyAppletPerviewLink: function copyAppletPerviewLink() {
      var Url2 = document.querySelector("#applet-copy");
      Url2.value = this.copy_applet_url;
      Url2.select(); // 选择对象

      document.execCommand("copy"); // 执行浏览器复制命令

      this.$message({
        message: "复制成功",
        type: 'success'
      });
    },
    downloadImg: function downloadImg() {
      var img = this.$refs['exCodeRef'].getElementsByTagName('img')[0]; // 构建画布

      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext('2d').drawImage(img, 0, 0); // 构造url

      var url = canvas.toDataURL('image/png');
      document.getElementById('downloadImg').setAttribute('href', url);
      document.getElementById('downloadImg').setAttribute('download', "".concat(this.name, "\u4E8C\u7EF4\u7801.jpg"));
      document.getElementById('downloadImg').click();
    },
    downloadAppetImg: function downloadAppetImg() {
      var img = document.getElementById('apple-qrcode').getElementsByTagName('img')[0];
      var url = img.src;
      var a = document.createElement('a');
      var event = new MouseEvent('click');
      a.download = "".concat(this.name, ".jpg");
      a.href = url;
      a.dispatchEvent(event);
    },
    handleClickUseModule: function handleClickUseModule() {
      this.$bus.$emit('useModule', this.moduleId);
      this.show = false;
    }
  }
};